import axios from 'axios'

export const restApi = axios.create({
  baseURL: import.meta.env.VITE_APP_REST_API_URL || '/'
})
